<template>
  <div id="TopHeader">
<!-- START OR TENDU HEADER TOOLBAR  -->
    <md-toolbar style="position:fixed; width:100%; overflow-y:hidden; z-index:11;">
      <md-button id="buttonTitle" title="Title" class="md-icon-button" @click.native="toggleLeftSidenav">
        <md-icon>menu</md-icon>
      </md-button>
      <h2 class="md-title">{{ homeTitle }}</h2>

      <md-button @click.native="closeLeftSidenav(), changePreviewSector(false), goScan()" class="md-icon-button">
        <md-icon>qr_code</md-icon>
      </md-button>
    </md-toolbar>

<!-- START OF TENDU SIDE NAVIGATION  -->
    <md-sidenav class="md-left" ref="leftSidenav" @open="open('Left')" @close="close('Left')">
      <md-toolbar class="md-small md-transparent">
        <md-list>
          <md-list-item v-if="isLogin">
            <md-avatar class="md-avatar-icon md-primary" style="color:#fff; font-size:20px; margin-left:-4px; padding-top:7px">
              {{ charAtUser }}
            </md-avatar>
              <p class="md-title">{{ userPrivileges.userNick }}</p>
          </md-list-item>

          <md-list-item v-else>
            <img src="../assets/tendu-icon.png" alt="tendu icon" width="30px" style="margin-left:-4px;">
            <div class="md-list-text-container">
              <div style="height:24px; font-family: 'Advent Pro', sans-serif; color:#00838f; font-size: 36px; margin-left:28px;">tendu</div>
            </div>
          </md-list-item>

        </md-list>
      </md-toolbar>

      <md-divider></md-divider>

      <md-list style="padding-top:0px !important;">
        <md-list-item>
          <router-link tag="md-button" style="width:100%;" to="/" class="md-icon-button" @click.native="closeLeftSidenav(), changeBack(true), changeNavigate(true), UPDATE_NUMBER(1), signOn()">
            <md-icon>home</md-icon> <span>Startseite</span>
          </router-link>
        </md-list-item>

        <md-list-item v-if="isLogin">
          <router-link tag="md-button" style="width:100%;" class="md-icon-button" to="/RouteLog" @click.native="closeLeftSidenav(), changeSidebar(true)">
            <md-icon>local_library</md-icon><span>Mein tendu</span>
          </router-link>
        </md-list-item>

        <md-list-item>
          <router-link tag="md-button" style="width:100%;" @click.native="closeLeftSidenav()" class="md-icon-button" to="/Scan">
            <md-icon>qr_code</md-icon><span>QR Code scannen</span>
          </router-link>
        </md-list-item>

        <md-divider></md-divider>

        <md-list-item v-if="isManager">
          <router-link tag="md-button" style="width:100%;" class="md-icon-button"
          @click.native="closeLeftSidenav()" to="/GymDashboard">
            <md-icon>dashboard</md-icon><span>Gym Dashboard</span>
          </router-link>
        </md-list-item>

        <md-list-item v-if="isSetter">
          <router-link tag="md-button" style="width:100%;" class="md-icon-button"
          @click.native="closeLeftSidenav()" to="/Gymlist">
            <md-icon>list</md-icon><span>Gym Routenliste</span>
          </router-link>
        </md-list-item>

        <md-list-item v-if="isLogin">
          <router-link tag="md-button" style="width:100%; color:#c51162; " @click.native="closeLeftSidenav(), doLogout()" class="md-icon-button" to="/" >
            <md-icon style="color:#c51162;" class="md-accent">exit_to_app</md-icon>
            <span>Abmelden</span>
          </router-link>
        </md-list-item>

      </md-list>

      <div class="helps">
        <md-divider></md-divider>
        <md-list style="padding-top:0px !important;">

          <md-list-item>
            <router-link tag="md-button" style="width:100%;" @click.native="goHelp(), closeLeftSidenav()" class="md-icon-button" to="/Help" >
              <span class="md-caption" style="padding-left:4px; color:#3c3c3c;">Hilfe</span>
            </router-link>
          </md-list-item>

          <md-list-item>
            <router-link tag="md-button" style="width:100%;" @click.native="closeLeftSidenav()" class="md-icon-button" to="/Info" >
              <span class="md-caption" style="padding-left:4px; color:#3c3c3c;">Wie funktioniert tendu?</span>
            </router-link>
          </md-list-item>

          <md-list-item>
            <router-link tag="md-button" style="width:100%;" @click.native="closeLeftSidenav()" class="md-icon-button" to="/Provider" >
              <span class="md-caption" style="padding-left:4px; color:#3c3c3c;">Impressum / Anbieter</span>
            </router-link>
          </md-list-item>

          <md-list-item>
            <router-link tag="md-button" style="width:100%;" @click.native="closeLeftSidenav()" class="md-icon-button" to="/Policy" >
              <span class="md-caption" style="padding-left:4px; padding-bottom:3px; letter-spacing: -0.005em; color:#3c3c3c; padding-top:4px;">Nutzungsbedingungen / Datenschutzerklärung</span>
            </router-link>
          </md-list-item>

        </md-list>
      </div>

    </md-sidenav>
  </div>
</template>
<script>
import { eventBus } from '../main'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'TopHeader',

  data () {
    return {
      isLogin: false,
      validMail: '',
      preview: false,
      lookQuery: ''
    }
  },

  mounted () {
    eventBus.$on('loginStatus', (isLogin, validMail) => {
      this.isLogin = isLogin
      this.validMail = validMail
      this.UPDATE_NUMBER(1)
      // console.log('numberSector', this.numberSector)
    })
  },

  computed: {
    ...mapState([
      'validUser',
      'sectorDetails',
      'isNavigate',
      'isNumber',
      'isBack',
      'sectorQuery',
      'userPrivileges',
      'numberSector',
      'isManager',
      'isSetter'
    ]),

    numSector () {
      return this.$store.state.sectorDetails.id
    },

    sectorId () {
      return this.$store.state.sectorDetails.id
    },

    homeTitle () {
      if (this.isNavigate && this.isBack) {
        return null
      } else {
        return 'tendu'
      }
    },

    charAtUser () {
      if (this.userPrivileges.userNick) {
        return this.userPrivileges.userNick.charAt(0)
      } else {
        return 't'
      }
    }
  },

  methods: {
    ...mapMutations([
      'changeNavigate',
      'changePreviewSector',
      'changeSidebar',
      'UPDATE_NUMBER',
      'changeBack',
      'changeLook',
      'changeDefaultSector',
      'changeUrlGym',
      'changeGymWalls',
      'changeSectoGymId',
      'changeGymTitle',
      'changeNumberSector',
      'changePageLoading'
    ]),

    toggleLeftSidenav () {
      this.$refs.leftSidenav.toggle()
      this.changePreviewSector(false)
    },

    closeLeftSidenav () {
      this.$refs.leftSidenav.close()
    },

    open (ref) {
      // console.log('Opened: ' + ref)
    },

    close (ref) {
      // console.log('Closed: ' + ref)
    },

    signOn () {
      eventBus.$emit('startSite', this.isNumber)
    },

    selectSector () {
      this.changeNumberSector(this.userPrivileges.sectorsAsRouteSetter.length - 1)
    },

    goHelp () {
      this.$router.push('/Help')
    },

    goScan () {
      this.$router.push('/Scan')
    },

    goPolicy () {
      this.$router.push('/Policy')
    },

    goProvider () {
      this.$router.push('/Provider')
    },

    doLogout () {
      this.$http.post('accesscontrol/logout', '')
        .then(response => {
          if (response.body === '') {
            window.document.location.assign('/')
            this.isLogin = false
            this.validMail = 'user@email.com'
          } else {
            // console.log('logout error')
          }
        })
    }
  }
}

</script>

<style scope>

  .md-sidenav {
    z-index:107;
    width:250px;
  }

  .helps{
    position: absolute;
    width:100%;
    vertical-align:bottom;
    bottom:0px;
    display:block;
  }

  .helps .md-list-item .md-list-item-container {
    min-height:32px !important;
  }

  .md-sidenav .md-sidenav-content{
      width:304px !important;
  }
  a:hover, a:focus{
    color:#C51162;
  }
</style>
